import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';
import { AppointmentService } from 'src/app/services/appointment.service';
import { ChangeDetectorRef } from '@angular/core';

declare var jQuery: any;

@Component({
  selector: 'app-directors',
  templateUrl: './directors.component.html',
  styleUrls: ['./directors.component.scss']
})
export class DirectorsComponent implements OnInit {
  directorsList: any = [];
  user: any
  confPass: string = '';
  openModal: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private router: Router, private appointmentService: AppointmentService, private spinner: NgxSpinnerService,private changeDetectorRef: ChangeDetectorRef) { }
  location: any = null
  userType = 1004;
  userForm!: FormGroup;
  buttonText: any = "Edit"
  
  userOption: boolean = false;
  noOfDiags: any
  successMessage: string = '';

  updateClient = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    mobileNo: new FormControl('', [Validators.required]),
    email: new FormControl('',  [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
    locationId: new FormControl('', [Validators.required]),
    username: new FormControl('', [Validators.required]),
    password: new FormControl(''),
    id: new FormControl(''),
    userOption:new FormControl('')
  });

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      mobileNo: ['', Validators.required],
      email: ['',  [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
      username: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]],
  });

    this.spinner.show();

    const successMessage = localStorage.getItem('successMessage');
    if (successMessage) {
      this.successMessage = successMessage;
      localStorage.removeItem('successMessage');
  
      setTimeout(() => {
        this.successMessage = '';
      }, 3000);
    }

    this.appointmentService.getLocations().subscribe((res) => {
      this.location = res;
    });
    forkJoin({
      requestOne: this.appointmentService
        .getUserAll(this.location, this.userType),
    }).subscribe(({ requestOne }) => {
      this.directorsList = requestOne.data;
      this.spinner.hide();

    });


  }
  createDirector() {
    this.router.navigate(
      ['/create-user'],
      { queryParams: { user: 'Director' } }
    );
  }
  getUser(user: any) {
    this.user = user

    this.userForm = this.formBuilder.group({
      locationId: [this.user.location, Validators.required],
      username: [this.user.username],
      firstName: [this.user.firstName, Validators.required],
      lastName: [this.user.lastName, Validators.required],
      password: ['', Validators.required],
      mobileNo: [this.user.mobileNo, Validators.required],
      email: [this.user.email, Validators.required],
      role: [this.user.role,],
    });

    this.userForm.disable();
    this.openModal = true


  }
  editForm() {
    if (this.buttonText == "Edit") {
      this.buttonText = "Save";
      this.userForm.enable()
    }

    else {
      this.buttonText = "Edit";
      this.userForm.disable()
    }
  }

  updateClientMethod(user:any) {
    this.userOption=user.userOption;
    this.successMessage = '';
    this.confPass='';
    this.updateClient.setValue({
      firstName: user.firstName,
      lastName: user.lastName,
      mobileNo: user.mobileNo,
      email: user.email,
      locationId: user.locationId,
      username: user.username,
      password: '',
      id: user.id,
      userOption:!user.userOption
    });

  }
  get f() { return this.updateClient.controls; }

  onClickSubmit(){
    this.spinner.show();
    this.appointmentService
      .updateUser(this.updateClient.value).subscribe(res => {
        this.successMessage = 'Director details updated successfully.';
        localStorage.setItem('successMessage', 'Director details updated successfully.');

        this.changeDetectorRef.detectChanges();
        jQuery("#editClientInfo").modal('hide');
        this.pageReload();
        this.spinner.hide();
      }
      , err => {
        // Handle error scenario
        this.successMessage = 'Error updating director details.';
        this.spinner.hide();
      });

  }


  pageReload() {
    location.reload()
  }



submit() {
  // Check if the entire form is valid
  if (this.userForm.valid && this.userForm.get('password')?.value === this.confPass) {
    // Form is valid - handle the submission logic
      console.log('Form Data:', this.userForm.value);
      // Here, you can call your service to handle the form submission
      // ...
  } else {
      // The form is invalid - trigger validation messages for each field
      Object.keys(this.userForm.controls).forEach(field => {
        const control = this.userForm.get(field);
        if (control) {
            control.markAsTouched({ onlySelf: true });
        }
    });

      // Check for password mismatch only if the password field is valid
      if (this.userForm.get('password')?.valid && this.userForm.get('password')?.value !== this.confPass) {
        console.error('Passwords do not match');
        // Additional logic for handling password mismatch
    }
  }
}

}
  
  



